import { render, staticRenderFns } from "./v-inline.vue?vue&type=template&id=00b8e8bc&"
import script from "./v-inline.vue?vue&type=script&lang=js&"
export * from "./v-inline.vue?vue&type=script&lang=js&"
import style0 from "./v-inline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports